/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EntityInsightsDatastoreConfig } from '../../Services/insights';
import {
  EVENT_RULE_LOGIC_OPERATOR_AND,
  EVENT_RULE_TYPE_REQUEST,
  EVENT_SUBSCRIPTION_ORIGIN_CLOUDFLARE,
  EntitySegmentEventSubscription,
} from '../../Services/segmentation';

/**
 * Create empty datastore event data.
 * @returns {EntityInsightsDatastoreConfig} Event datastore config.
 */
export function createEmptyDatastoreEvent(): EntityInsightsDatastoreConfig {
  return {
    eventType: `datastore`,
    filter: {
      collectionPrefix: ``,
      datastoreURL: ``,
    },
    index: {
      target: ``,
    },
    name: ``,
    properties: {
      [``]: ``,
    },
  };
}

/**
 * Create empty segment event data.
 * @returns {EntitySegmentEventSubscription} Segment event config.
 */
export function createEmptyWebBehaviorEvent(): EntitySegmentEventSubscription {
  return {
    attributeid: ``,
    name: ``,
    operator: EVENT_RULE_LOGIC_OPERATOR_AND,
    origin: EVENT_SUBSCRIPTION_ORIGIN_CLOUDFLARE,
    property: [],
    relevance: null,
    type: EVENT_RULE_TYPE_REQUEST,
    uniqueCustomId: null,
  };
}
